import { permissions, composerSettings } from '@ddc-webplatform/cmsc-modules';

/** Mirrors legacy: canEditSitemapCollection: ddc.composer.access.has('ACCT_ACL_SmartSites.CustomSitemap') */
export const canEditSitemapCollection = permissions.hasAnyPermissions(['ACCT_ACL_SmartSites.CustomSitemap']) ?? false;
export const canAccessFordDirectProgram = permissions.hasAnyPermissions(['ACCT_PROGRAM_forddirect']) ?? false;

/** True when the logged-in user is an internal (CC Support) user. */
export const isInternalUser = permissions.isInternalUser() ?? false;

/**
 * Mirrors legacy canEditSiteBuilderPagePath from composer-ui/Permissions.js (line 283):
 *   this.has('COMPOSER_SB_EDIT_PAGE_PATH') || this.isInternalUser()
 * Gates the Page Alias, Page ID, and page path fields.
 * Reads directly from ComposerSettings.permissions to match the legacy has() data source.
 */
const { permissions: composerPermissions } = composerSettings.getComposerSettings();
export const canEditNavigation = composerPermissions?.COMPOSER_SB_EDIT_PAGE_PATH === true || isInternalUser;

export const drawerWidth = 350;

export const drawerBgColor = '#2c2c2c';

export const defaultContentSx = {
	p: 2
};

export const defaultFooterSx = { p: 0 };

export const labelSx = {
	fontWeight: 400,
	fontSize: '16px',
	lineHeight: '20px',
	mb: 2
};

export const DEFAULT_MAX_BATCH_SIZE = 50;

export const LD_FLAG_BATCH_DELETE_SIZE_LIMIT = 'sitemap-editor-batch-delete-size-limit';

export const LD_FLAG_BATCH_UPDATE_SIZE_LIMIT = 'sitemap-editor-batch-update-size-limit';
